import { Injectable, NgZone } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';


type ChatGPTAssitantServerSendEvent = {

    eventName: string,
    eventData: any
};
/**
* Server-Sent Events service
*/
@Injectable({
   providedIn: 'root'
})
export class EventSourceService {
   private eventSource: any;

   /**
    * constructor
    * @param zone - we need to use zone while working with server-sent events
    * because it's an asynchronous operations which are run outside of change detection scope
    * and we need to notify Angular about changes related to SSE events
    */
   constructor(private zone: NgZone) {}

   /**
    * Method for creation of the EventSource instance
    * @param url - SSE server api path
    * @param options - configuration object for SSE
    */
   getEventSource(url: string, options: EventSourceInit): EventSource {
        // Append the 'ngsw-bypass' parameter to the URL
        const bypassUrl = url.includes('?')
            ? `${url}&ngsw-bypass=true`
            : `${url}?ngsw-bypass=true`;

        return new EventSource(bypassUrl, options);
   }

   /**
    * Method for establishing connection and subscribing to events from SSE
    * @param url - SSE server api path
    * @param options - configuration object for SSE
    * @param eventNames - all event names except error (listens by default) you want to listen to
    */
   connectToServerSentEvents(url: string, options: EventSourceInit, eventNames: string[] = []): Observable<ChatGPTAssitantServerSendEvent> {
       this.eventSource = this.getEventSource(url, options);

       return new Observable((subscriber: Subscriber<ChatGPTAssitantServerSendEvent>) => {
            this.eventSource.onerror = error => {
                console.error("SSE connection error:", error);
                this.close();
                this.zone.run(() => subscriber.error(error));

            };
            this.eventSource.onopen = ev => {
               console.log("eventSource opening....");
            };
            eventNames.forEach((event: string) => {
                this.eventSource.addEventListener(event, eventObj => {
                    this.zone.run(() => subscriber.next({eventName: event, eventData:eventObj.data}));
                    if(event=='done'){
                        this.close();
                    }
                });
            });

            // Cleanup logic for unsubscription
            return () => this.close();

       });
   }


   /**
    * Method for closing the connection
    */
   close(): void {
       if (!this.eventSource) {
           return;
       }
       console.log("EventSource Closed");
       this.eventSource.close();
       this.eventSource = null;
   }
}